import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';

class HttpError extends Error {
    constructor(message, status, body = null) {
        super(message);
        //this.message = message;
        this.status = status;
        this.body = body;
        //this.name = this.constructor.name;
        this.name = 'HttpError';
        
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, this.constructor);
        } else {
            this.stack = new Error(message).stack;
        }
        
        this.stack = new Error().stack;
        console.log(body);
        // 메세지 문구 만들기 
        if( body && body.detailCode ) {
            if(body.data && body.data.msgArgs) {
                this.message = <FormattedHTMLMessage id={`response.error.${body.detailCode}`} values={body.data.msgArgs} defaultMessage={message} />;
            } else {
                this.message = <FormattedHTMLMessage id={`response.error.${body.detailCode}`} defaultMessage={message} />;
            }
        } else {
            this.message = <FormattedHTMLMessage id={`response.error.${status}`} defaultMessage={message} />;
        }
    }
}

export default HttpError;